import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import QCPage from "./QCPage";
import NewQCPage from "../New QC page/NewQCPage";
function Pages() {

    const { year, page } = useParams();
    const BASE_URL_LOC = process.env.REACT_APP_SERVER_LOCATION;
    const [status, setStatus] = useState('');
    const [pageType, setPageType] = useState('');


    useEffect(() => {
        const getState = async () => {
            const response = await fetch(`${BASE_URL_LOC}/getState`, {
                method: "post",
                headers: {
                    "authentication-token": localStorage.getItem("token"),
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "authentication-token",
                    "Access-Control-Expose-Headers": "authentication-token",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ file_year: year, file_name: page }),
                mode: "cors"
            });
            const data = await response.json();
            console.log("data", data);
            setStatus(data?.file_status);
            setPageType(data?.page_type);
        }
        getState();
    }, []);
    console.log("status",status)
    if (status === 'Processed' && pageType === 'ringing_page') {
        return <QCPage year={year} page={page} status={status} pType={pageType} type={"/getTable"} />
    } else if ((status === 'QC_Ongoing' || status === "QC_Done" || status === "Merged") && pageType === 'ringing_page') {
        return <QCPage year={year} page={page} status={status} pType={pageType} type={"/getQCTable"} />
    } else {
        if (status === 'Processed' && pageType !== 'ringing_page') {
            return <NewQCPage year={year} page={page} status={status} pType={pageType} type={"/getTable"} />
        } else if ((status === 'QC_Ongoing' || status === "QC_Done" || status === "Merged") && pageType !== 'ringing_page') {
            return <NewQCPage year={year} page={page} status={status} pType={pageType} type={"/getQCTable"} />
        }
    }

}

export default Pages;